import { Box } from '@mui/material'
import { CustomDivider } from './CustomDivider'
import { BoxProps } from '@mui/system'
import { themeColors } from '@app/constants'
import theme from '@app/lib/materialui/theme'

interface HeaderSectionProps extends BoxProps {
	hideBottomDivider?: boolean
	noBottomPadding?: boolean
	topPadding?: number
	bottomPadding?: number
	transparent?: boolean
	children?: React.ReactNode
}

export function HeaderSection(props: HeaderSectionProps) {
	const {
		children,
		hideBottomDivider = false,
		noBottomPadding = false,
		topPadding = 2.5,
		bottomPadding = 2.5,
		transparent = false,
		sx,
		...boxProps
	} = props

	return (
		<Box
			sx={{
				backgroundColor: transparent
					? 'transparent'
					: themeColors.white,
				...sx,
			}}
			{...boxProps}
		>
			{
				<Box
					sx={{
						paddingLeft: theme.spacing(3),
						paddingRight: theme.spacing(3),
						paddingTop: theme.spacing(topPadding),
						paddingBottom: theme.spacing(bottomPadding),
						...(noBottomPadding && {
							paddingBottom: 0,
						}),
					}}
				>
					{children}
				</Box>
			}

			{!hideBottomDivider && <CustomDivider mb={0} mt={0} />}
		</Box>
	)
}
